
jQuery( document ).ready(function() {
  if(jQuery.cookie('_shopify_diamondsetting')){
     jQuery('#completering').show();
  }else{
    jQuery('#add-diamond').show();   
  }
});

function addDiamond() {
  
//  alert($.cookie('_shopify_diamondsetting'));
  let shop_domain = Shopify.shop;
  let productId = meta.product.id;
  var ringData = [];
  var data = {};
  data.ringsizewithdia = document.getElementById('ring-size').value;
  data.ringmaxcarat = document.getElementById('ringmaxcarat').value;
  data.ringmincarat = document.getElementById('ringmincarat').value;
  data.centerStoneFit = document.getElementById('centerStoneFit').value;          
  //           data.centerStoneSize = caratRange;
  //           data.sideStoneQuality = jQuery("#sidestonequalityvalue").val();
  data.setting_id = document.getElementsByName('id')[0].value;      
  data.product_id = productId;
  data.isLabSetting = document.getElementById('islabsettings').value;
  ringData.push(data);
  var expire = new Date();
  expire.setDate(expire.getDate() + 0.2 * 24 * 60 * 60 * 1000);
  jQuery.cookie("_shopify_ringsetting", JSON.stringify(ringData), {
    path: '/',
    expires: expire
  });
  console.log('redirecting');
  var redirect_url = "https://" + shop_domain + "/apps/ringbuilderadvance/diamondtools";
  console.log(redirect_url);
  //location.replace(redirect_url)
  window.location.href = redirect_url;
}

function completeRing() {
  
//  alert($.cookie('_shopify_diamondsetting'));
  let shop_domain = Shopify.shop;
  let productId = meta.product.id;
  var ringData = [];
  var data = {};
  data.ringsizewithdia = document.getElementById('ring-size').value;
  data.ringmaxcarat = document.getElementById('ringmaxcarat').value;
  data.ringmincarat = document.getElementById('ringmincarat').value;
  data.centerStoneFit = document.getElementById('centerStoneFit').value;          
  data.setting_id = document.getElementsByName('id')[0].value;      
  data.product_id = productId;
  data.isLabSetting = document.getElementById('islabsettings').value;
  ringData.push(data);
  var expire = new Date();
  expire.setDate(expire.getDate() + 0.2 * 24 * 60 * 60 * 1000);
  jQuery.cookie("_shopify_ringsetting", JSON.stringify(ringData), {
    path: '/',
    expires: expire
  });
  console.log('redirecting');
  var redirect_url = "https://" + shop_domain + "/apps/ringbuilderadvance/completering";
  console.log(redirect_url);
//   location.replace(redirect_url)
  window.location.href = "https://gemfind-demo-store-3.myshopify.com/apps/ringbuilderadvance/completering/";
}

function chooseDiamond() {
  let shop_domain = Shopify.shop;
  console.log('redirecting');
  var redirect_url = "https://" + shop_domain + "/apps/ringbuilderadvance/diamondtools";
  console.log(redirect_url);
  location.replace(redirect_url)
}


var show = function(id) {
  $('.popup').css('display','block');
}

var show_request_info = function(id) {
  $('.request_info').css('display','block');
}

var show_email_friend = function(id) {
  $('.email_friend').css('display','block');
}

var show_schedule = function(id) {
  $('.schedule').css('display','block');
}

$(function() {
  $("#drop_hint").click(function(e) {
   
    var name = document.getElementById('name').value;
    let err_name;
    if (!name) {
      err_name = "Name is required";
    }else{
      err_name = "";
    }
    document.getElementById("err-name").innerHTML = err_name;
    
    var email = document.getElementById('email').value;
    let err_email;    
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(email)) {
           err_email = "Enter valid Email";
     }
    else{
           err_email = "";
     }
    document.getElementById("err-email").innerHTML = err_email;
    
    var hint_Recipient_name = document.getElementById('hint_Recipient_name').value;
    let err_rcpt_name;
    if (!hint_Recipient_name) {
      err_rcpt_name = "Recipient name is required";
    }else{
      err_rcpt_name = "";
    }
    document.getElementById("err-rcpt-name").innerHTML = err_rcpt_name;
    
    var hint_Recipient_email = document.getElementById('hint_Recipient_email').value;
    let err_rcpt_email;    
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(hint_Recipient_email)) {
           err_rcpt_email = "Enter valid recipient mail";
     }
    else{
           err_rcpt_email = "";
     }
    document.getElementById("err-rcpt-email").innerHTML = err_rcpt_email;
    
    var reason_of_gift = document.getElementById('reason_of_gift').value;
    let err_reason;
    if (!reason_of_gift) {
      err_reason = "Reason of gift is required";
    }else{
      err_reason = "";
    }
    document.getElementById("err-reason").innerHTML = err_reason;
    
    var hint_message = document.getElementById('hint_message').value;
    let err_msg;
    if (!hint_message) {
      err_msg = "Hint message is required";
    }else{
      err_msg = "";
    }
    document.getElementById("err-msg").innerHTML = err_msg;
    
    var deadline = document.getElementById('deadline').value;
    let err_deadline;
    if (!deadline) {
      err_deadline = "Deadline is required";
    }else{
      err_deadline = "";
    }
    document.getElementById("err-deadline").innerHTML = err_deadline;
    var shopurl = Shopify.shop;
    var settingid = document.getElementsByName('id')[0].value;
    var islabsettings = document.getElementById('islabsettings').value;
    var ring_url = location.href;
    $.ajax({
      url: 'https://rb-advance-dev.partners.gemfind.com/api/dropHintApi',
      type: 'post',
      data: {name : name,email: email,hint_Recipient_name: hint_Recipient_name,hint_Recipient_email: hint_Recipient_email,reason_of_gift: reason_of_gift,
             hint_message:hint_message,deadline: deadline,shopurl: shopurl,settingid: settingid,islabsettings: islabsettings,ring_url: ring_url},
      success: function(data) {
        console.log(data.status);
        if(data.status == 'success'){
	      	$('.popup').css('display','none');
        }
      }
    });
  });
});

$(function() {
  $("#request-info-btn").click(function(e) {
    var name = document.getElementById('request_name').value;
    let err_name;
    if (!name) {
      err_name = "Name is required";
    }else{
      err_name = "";
    }
    document.getElementById("err-name-req").innerHTML = err_name;
    
    var email = document.getElementById('request_email').value;
    let err_email;    
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(email)) {
           err_email = "Enter valid Email";
     }
    else{
           err_email = "";
     }
    document.getElementById("err-email-req").innerHTML = err_email;
    
    var phone_no = document.getElementById('phone_no').value;
    let err_phone_no;    
    var regex = /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/;
    if(!regex.test(phone_no)) {
           err_phone_no = "Enter valid Phone number";
     }
    else{
           err_phone_no = "";
     }
    document.getElementById("err-phone-req").innerHTML = err_phone_no;
    
    var message = document.getElementById('message').value;
    let err_msg_req;
    if (!message) {
      err_msg_req = "Message is required";
    }else{
      err_msg_req = "";
    }
    document.getElementById("err-msg-req").innerHTML = err_msg_req;
    
    var contact_preference = document.getElementById('contact_preference').value;
    let err_cp;
    if (!message) {
      err_cp = "Contact Preference is required";
    }else{
      err_cp = "";
    }
    document.getElementById("err-contact_preference").innerHTML = err_cp;
    
    var shopurl = Shopify.shop;
    var settingid = document.getElementsByName('id')[0].value;
    var islabsettings = document.getElementById('islabsettings').value;
    var ring_url = location.href;
    console.log(contact_preference);
    $.ajax({
      url: 'https://rb-advance-dev.partners.gemfind.com/api/reqInfoApi',
      type: 'post',
      data: {name : name,email: email,phone_no: phone_no,message: message,contact_preference: contact_preference,shopurl: shopurl,
             settingid: settingid,islabsettings: islabsettings,ring_url: ring_url},
      success: function(data) {
        if(data.status == 'success'){
	      	$('.request_info').css('display','none');
        }
      }
    });

  });
});

$(function() {
  $("#email-friend-btn").click(function(e) {
    var name = document.getElementById('email_friend_name').value;
    let err_name;
    if (!name) {
      err_name = "Name is required";
    }else{
      err_name = "";
    }
    document.getElementById("err-name-frnd").innerHTML = err_name;
    
    var email = document.getElementById('your_email').value;
    let err_email;    
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(email)) {
           err_email = "Enter valid Email";
     }
    else{
           err_email = "";
     }
    document.getElementById("err-email-frnd").innerHTML = err_email;
    
    var frnd_name = document.getElementById('friend_name').value;
    let err_frnd_name;
    if (!frnd_name) {
      err_frnd_name = "Friend name is required";
    }else{
      err_frnd_name = "";
    }
    document.getElementById("err-frndname").innerHTML = err_frnd_name;
    
    var frnd_email = document.getElementById('friend_email').value;
    let err_frnd_email;    
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(frnd_email)) {
           err_frnd_email = "Enter valid Friend's Email";
     }
    else{
           err_frnd_email = "";
     }
    document.getElementById("err-frndemail").innerHTML = err_frnd_email;
    
    var frnd_message = document.getElementById('email_message').value;
    let err_msg_frnd;
    if (!frnd_message) {
      err_msg_frnd = "Message is required";
    }else{
      err_msg_frnd = "";
    }
    document.getElementById("err_msg_frnd").innerHTML = err_msg_frnd;
    
    
    var shopurl = Shopify.shop;
    var settingid = document.getElementsByName('id')[0].value;
    var islabsettings = document.getElementById('islabsettings').value;
    var ring_url = location.href;
    console.log(ring_url);
    $.ajax({
      url: 'https://rb-advance-dev.partners.gemfind.com/api/emailFriendApi',
      type: 'post',
      data: {name : name,email: email,frnd_name: frnd_name,frnd_email: frnd_email,frnd_message: frnd_message,shopurl: shopurl,
             settingid: settingid,islabsettings: islabsettings,ring_url: ring_url},
      success: function(data) {
        console.log(data);
        if(data.status == 'success'){
	      	$('.email_friend').css('display','none');
        }
      }
    });

  });
});

$(function() {
  $("#schedule-btn").click(function(e) {
    var name = document.getElementById('schedule_name').value;
    let err_name;
    if (!name) {
      err_name = "Name is required";
    }else{
      err_name = "";
    }
    document.getElementById("err-name-scdl").innerHTML = err_name;
    
    var email = document.getElementById('schedule_email').value;
    let err_scdl_email;    
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(email)) {
           err_scdl_email = "Enter valid Email";
     }
    else{
           err_scdl_email = "";
     }
    document.getElementById("err-email-scdl").innerHTML = err_scdl_email;
    
    var phone_no = document.getElementById('schedule_phone').value;
    let err_phone_no;    
    var regex = /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/;
    if(!regex.test(phone_no)) {
           err_phone_no = "Enter valid Phone number";
     }
    else{
           err_phone_no = "";
     }
    document.getElementById("err-phone-scdl").innerHTML = err_phone_no;
    
    var schl_message = document.getElementById('schedule_message').value;
    let err_msg_req;
    if (!schl_message) {
      err_msg_req = "Message is required";
    }else{
      err_msg_req = "";
    }
    document.getElementById("err-msg-scdl").innerHTML = err_msg_req;
    
    var select_schedule = document.getElementById('select_schedule').value;
    let err_location_scdl;
    if (!select_schedule) {
      err_location_scdl = "Location is required";
    }else{
      err_location_scdl = "";
    }
    document.getElementById("err-location-scdl").innerHTML = err_location_scdl;
    
    var availability_date = document.getElementById('schedule_available').value;
    let err_date_scdl;
    if (!availability_date) {
      err_date_scdl = "Availability date is required";
    }else{
      err_date_scdl = "";
    }
    document.getElementById("err-date-scdl").innerHTML = err_date_scdl;
    
    
    var appnt_time = document.getElementById('appt_time').value;
    let err_appnt_time;
    if (!appnt_time) {
      err_appnt_time = "Append time is required";
    }else{
      err_appnt_time = "";
    }
    document.getElementById("err-time-scdl").innerHTML = err_appnt_time;
    
    var shopurl = Shopify.shop;
    var settingid = document.getElementsByName('id')[0].value;
    var islabsettings = document.getElementById('islabsettings').value;
    var ring_url = location.href;
    console.log(ring_url);
    console.log(appnt_time);
    $.ajax({
      url: 'https://rb-advance-dev.partners.gemfind.com/api/scheViewApi',
      type: 'post',
      data: {ring_url: ring_url,name : name,email: email,phone_no: phone_no,schl_message: schl_message,location: select_schedule,availability_date: availability_date,shopurl: shopurl,
             appnt_time: appnt_time,settingid: settingid,islabsettings: islabsettings,},
      success: function(data) {
       if(data.status == 'success'){
	      $('.schedule').css('display','none');
        }
      	
      }
    });

  });
});